import styled, { keyframes } from "styled-components";

export const placeHolderShimmer = keyframes`
0% {
  background-position: -46.8rem 0;
}

100% {
  background-position: 46.8rem 0; 
}
`;

export const Placeholder = styled.div`
  background-image: linear-gradient(
    to right,
    #d1e5ff 0%,
    #e2efff 20%,
    #d1e5ff 40%,
    #d1e5ff 100%
  );
  background-size: 50rem 3.8rem;
  animation-name: ${placeHolderShimmer};
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  display: ${(p) => (p.display ? p.display : "inline-flex")};
  width: ${(p) => (p.ldrWidth ? p.ldrWidth : "")};
  height: ${(p) => (p.ldrHeight ? p.ldrHeight : "")};
  margin: ${(p) => (p.margin ? p.margin : "")};
  background-color: ${(p) => (p.bgColor ? p.bgColor : "#d1e5ff")};
`;
